var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Property, ChildProperty } from '@syncfusion/ej2-base';
/**
 * A collection of JSON objects where each object represents a layer.
 * Layer is a named category of diagram shapes.
 */
export class Layer extends ChildProperty {
    // tslint:disable-next-line:no-any
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(parent, propName, defaultValue, isArray) {
        super(parent, propName, defaultValue, isArray);
        /**  @private   */
        this.objectZIndex = -1;
        /**   @private  */
        this.zIndexTable = {};
        this.objects = [];
    }
}
__decorate([
    Property('')
], Layer.prototype, "id", void 0);
__decorate([
    Property(true)
], Layer.prototype, "visible", void 0);
__decorate([
    Property(false)
], Layer.prototype, "lock", void 0);
__decorate([
    Property()
], Layer.prototype, "objects", void 0);
__decorate([
    Property()
], Layer.prototype, "addInfo", void 0);
__decorate([
    Property(-1)
], Layer.prototype, "zIndex", void 0);
